module.exports = __webpack_public_path__ + "img/linkedin.6ee10faf.svg";